// John Eldhose 20190405
const LMDCache = (state = [], action) => {
  switch (action.type) {
    case 'LMDCache':
      return action.lmdcache;
    default:
  }
  return state;
};

export default LMDCache;



// WEBPACK FOOTER //
// ./src/reducers/LMDCache.js